import { evalShowWhen } from '../core/showWhen';

// What a public form (form link, public intake) shows and sends, as pure functions of the field list the server gave it and what has been typed.
// The server passes `show_when` through only when every field it names is also on the form (appdata/form_links.py's `public_show_when`), so
// every rule here is one this page can actually evaluate.

const visibleRule = (spec, values) => {
  const rule = spec.show_when;
  return Array.isArray(rule) ? rule.every((r) => evalShowWhen(r, values)) : evalShowWhen(rule, values);
};

/** The fields to show now: a field with a `show_when` appears only while it holds. */
export function visibleFields(fields, values) {
  return (fields || []).filter((spec) => visibleRule(spec, values || {}));
}

/**
 * The values to send: only what is on screen (a field the rules hide is never sent, so a hidden required field cannot refuse the submit and a
 * stale answer to a hidden question does not go along), and only what was touched. Text and numbers go as typed; a yes/no is a real boolean, a
 * rating a number, a multi-choice an array.
 */
export function publicPayload(fields, values) {
  const out = {};
  for (const spec of visibleFields(fields, values)) {
    const v = (values || {})[spec.key];
    if (v === undefined || v === null) continue;      // never touched. A cleared answer ('' or []) IS sent: on an update link that is how a value is blanked
    out[spec.key] = v;
  }
  return out;
}

// The text-input class string shared by the public form and the signing card.
export const INPUT = 'w-full rounded-lg border border-sand dark:border-espresso-700 bg-paper ' +
  'dark:bg-espresso-900 px-3 py-2.5 text-base text-ink dark:text-paper ' +
  'outline-hidden focus:border-sage-500 dark:focus:border-sage-400';
